import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import SejaUmaMarcaDoBemPage from "@/pages/SejaUmaMarcaDoBemPage";

export const Route = createFileRoute("/seja-uma-marca-do-bem")({
  head: () => seoHead({
    title: "Seja uma Marca do Bem | Shopping do Bem",
    description: "Conheça o programa Marca do Bem, receba o selo oficial após aprovação e aproxime sua empresa de um ecossistema de impacto positivo.",
    path: "/seja-uma-marca-do-bem",
    ogImage: null,
  }),
  component: SejaUmaMarcaDoBemPage,
});